import { Box, Button, CircularProgress, Dialog, FormHelperText, IconButton, TextField, Typography, useTheme } from '@mui/material'
import React, { useEffect, useState } from 'react'

import { Icons } from '../../../utils/utilities'
import { MAX_EXTENSION_REASON_LENGTH } from '../../../shared/utils/constants'

const AccessExtensionRequestDialog = ( { open, onClose, onSubmit, submitting = false } ) => {

    const [reason, setReason] = useState( "" )

    const { border, layout } = useTheme()

    useEffect( () => {
        if ( open ) setReason( "" )
    }, [open] )

    const trimmedReason = reason.trim()
    const reasonTooLong = trimmedReason.length > MAX_EXTENSION_REASON_LENGTH

    const handleSubmit = () => {
        if ( !trimmedReason || reasonTooLong ) return
        onSubmit( trimmedReason )
    }

    return (
        <Dialog open={open} maxWidth="xs" slotProps={{ paper: { sx: { maxWidth: "xs", width: "90%" } } }} >
            <Box display="flex" borderBottom={border[1]} padding="10px 20px" gap={layout.sectionsGap} justifyContent="space-between" alignItems="center" >
                <Typography variant="h1" fontWeight="600" component="h1" fontSize="16px"  >Send Access Extension Request</Typography>
                <IconButton disabled={submitting} onClick={onClose}  >
                    {Icons.default.CloseIcon}
                </IconButton>
            </Box>
            <Box padding="20px">
                <Typography variant='subtitle2' gutterBottom display="block">Specify reason (Maximum {MAX_EXTENSION_REASON_LENGTH} characters) *</Typography>
                <TextField value={reason} onChange={( event ) => setReason( event.target.value )} multiline placeholder='Reason for extension' rows={2} fullWidth error={reasonTooLong} />
                <FormHelperText>
                    <Typography fontWeight="inherit" component="span" color={reasonTooLong ? "error" : "textSecondary"} fontSize="inherit">
                        {trimmedReason.length} / {MAX_EXTENSION_REASON_LENGTH} characters
                    </Typography>
                </FormHelperText>
            </Box>
            <Box display="flex" gap="10px" alignItems="center" flexWrap="wrap" padding="20px" paddingTop="0" justifyContent="flex-end">
                <Button size='small' disabled={submitting} onClick={onClose} color='greyed'>Cancel</Button>
                <Button size='small' disabled={submitting || !trimmedReason || reasonTooLong} disableElevation onClick={handleSubmit} color='primary' variant='contained' endIcon={submitting ? <CircularProgress size={14} /> : null}>Submit request</Button>
            </Box>
        </Dialog>
    )
}

export default AccessExtensionRequestDialog